import { TableCell, TableRow } from '@/components/ui/table'
import { formatVnd } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

/** Chỉ những trường dòng này thật sự đọc — khai báo hẹp để dùng được cho cả
 *  kiểu draft từ API (màn chi tiết) lẫn kiểu state của form. */
export interface MaterialRowData {
    material_name: string
    quantity: number
    unit_price: number
    discount_percent?: number | null
}

interface Props {
    d: MaterialRowData
    /** 'sub' = vật tư theo định mức, thụt lề dưới đúng sản phẩm của nó.
     *  'standalone' = vật tư nhân viên tự thêm, ngang hàng dòng sản phẩm. */
    variant: 'sub' | 'standalone'
}

/**
 * Dòng vật tư ở màn CHI TIẾT đơn — read-only, giá là snapshot của draft đã lưu.
 *
 * Cả hai biến thể đều nằm trong bảng hàng hóa (5 cột: tên, SL, đơn giá, CK,
 * thành tiền) nên vật tư thêm tay cũng có cột CK — trước đây bảng riêng của nó
 * thiếu cột này, khiến thành tiền thấp hơn SL × đơn giá mà không giải thích.
 */
export function OrderMaterialDetailRow({ d, variant }: Props) {
    const discount = d.discount_percent ?? 0
    const subtotal = d.unit_price * d.quantity * (1 - discount / 100)
    const isSub = variant === 'sub'

    return (
        <TableRow className="bg-muted/20">
            <TableCell className={isSub ? 'pl-8 text-sm' : 'text-sm'}>
                <span className="inline-flex items-center gap-1">
                    {isSub ? (
                        <span className="text-muted-foreground">↳</span>
                    ) : null}
                    {d.material_name}
                    {!isSub ? (
                        <span className="text-xs text-muted-foreground">
                            {m.material_row_suffix()}
                        </span>
                    ) : null}
                </span>
            </TableCell>
            <TableCell className="text-right text-sm">{d.quantity}</TableCell>
            <TableCell className="text-right text-sm">
                {formatVnd(d.unit_price)}
            </TableCell>
            <TableCell className="text-right text-sm">{discount}%</TableCell>
            <TableCell className="text-right text-sm font-medium">
                {formatVnd(subtotal)}
            </TableCell>
        </TableRow>
    )
}
